<div class="cancel-request-modal">
  <div class="modal-header">
    <button
      aria-label="Close"
      class="close"
      data-dismiss="modal"
      type="button"
      (click)="handleModalHide()"
    >
      <span aria-hidden="true"> × </span>
    </button>
  </div>
  <div class="modal-body">
    <div class="info">
      <h3>Cancel Medication Request</h3>
    </div>
    <form
        [formGroup]="cancellationForm"
        (ngSubmit)="onContinueEvent()"
      >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="form-control-label required" for="cancellation-reason">
              Cancellation Reason
            </label>
            <input
              type="text"
              formControlName="cancellationReason"
              id="cancellation-reason"
              name="cancellation-reason"
              class="input form-control"
              placeholder="Cancellation Reason"
            />
          </div>
        </div>
      </div>
      <div class="actions">
        <button class="btn action-btn back-btn" type="button" (click)="handleModalHide()">
          Discard
        </button>
        <button class="btn action-btn continue-btn" type="submit" [disabled]="checkSubmitDisable()">
          Continue
        </button>
      </div>
    </form>
  </div>
</div>
